
import RcDomainMap from "../../common/RcDomainMap.js";
import Comment from "./Comment.js";
import InspectionUtils from '../inspection/InspectionUtils.js';

export default class CommentMap extends RcDomainMap {
  
  static MODEL_NAME = "VehicleInspectionCommentMap";

  constructor(domain, data) {
    super(domain, data, CommentMap.MODEL_NAME);
  }
  
  find() {
    var keys = this.keys();
    var found = new CommentMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.comments().findById(key);
      var item = new Comment(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var comment = this.getComment(key);
      values.push(comment);
    }
    return values;
  }
  
  sorted() {
    var list = this.list();
    return list.sort(InspectionUtils.SortByCreatedDate);
  }
  
  getComment(key) {
    var value = super.get(key);
    return new Comment(this.domain, value);
  }
  
  copy() {
    var data = this._copy();
    return new CommentMap(this.domain, data);
  }
}